import { Button, ButtonVariant } from "@src/components/button/Button";
import { CommonModal } from "@src/components/modal/CommonModal";
import { DeliveryClassification, hasMobileDeliveryType } from "@src/utils/deliveryClassification";
import React, { useState } from "react";
import { DeliveryClassificationRadios } from "./DeliveryClassificationRadios";
import styles from "./DeliveryClassificationModal.module.scss";

interface IDeliveryClassificationModalProps {
	externalNotes: string;
	saving: boolean;
	error: string | null;
	onCancel: () => void;
	onSave: (classification: DeliveryClassification) => void;
}

export const DeliveryClassificationModal: React.FC<IDeliveryClassificationModalProps> = ({
	externalNotes,
	saving,
	error,
	onCancel,
	onSave,
}) => {
	const [classification, setClassification] = useState<DeliveryClassification | null>(null);

	return (
		<CommonModal
			controlSize="sm"
			closeModal={onCancel}
			title="Inventory Classification"
			padding="2rem"
			content={
				<div className={styles.body}>
					<DeliveryClassificationRadios
						name="listingDeliveryClassification"
						value={classification}
						onChange={setClassification}
						hardTicketsDisabled={hasMobileDeliveryType(externalNotes)}
						error={error}
					/>
				</div>
			}
			buttons={
				<div className={styles.buttons}>
					<Button onClick={onCancel} disabled={saving} variant={ButtonVariant.Secondary}>
						Cancel
					</Button>
					<Button
						isLoading={saving}
						disabled={!classification || saving}
						onClick={() => classification && onSave(classification)}
						variant={ButtonVariant.Primary}>
						Save
					</Button>
				</div>
			}
		/>
	);
};
